import { render, staticRenderFns } from "./buttonsManager.vue?vue&type=template&id=794a17ae&scoped=true&"
import script from "./buttonsManager.vue?vue&type=script&lang=js&"
export * from "./buttonsManager.vue?vue&type=script&lang=js&"
import style0 from "./buttonsManager.vue?vue&type=style&index=0&id=794a17ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794a17ae",
  null
  
)

export default component.exports